import React from "react";
import { Link } from "react-router-dom";
import {
  FaInstagram,
  FaXTwitter,
  FaLinkedin,
  FaFacebook,
  FaYoutube,
} from "react-icons/fa6";
import "./Footer.css";
import Logo from "./Logo";
//import FooterBg from "../assets/Footer.webp";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Logo & Social */}
        <div className="footer-top">
          <div className="footer-brand">
            <Link to="/" className="footer-logo-link">
              <Logo /> {/* <-- imported from ./Logo */}
              <span className="footer-company-name">DB4Cloud Technologies</span>
            </Link>
          </div>

          <div className="footer-social">
            <h4 className="footer-social-title">Follow Us</h4>
            <div className="footer-social-icons">
              <a
                href="https://www.instagram.com/db4cloudtechnologies/"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social-link"
              >
                <FaInstagram />
              </a>
              <a
                href="https://x.com/DB4Cloud"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social-link"
              >
                <FaXTwitter />
              </a>
              <a
                href="https://www.linkedin.com/company/103363660/admin/dashboard/"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social-link"
              >
                <FaLinkedin />
              </a>
              <a
                href="https://www.facebook.com/people/Db4Cloud-Technologies-Pvt-Ltd/61563263484445/"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social-link"
              >
                <FaFacebook />
              </a>
              <a
                href="https://www.youtube.com/channel/UCvhr4y0CQY8C2-B8xcB9X6w"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social-link"
              >
                <FaYoutube />
              </a>
            </div>
          </div>
        </div>

        <hr className="footer-divider" />

        {/* Content Grid */}
        <div className="footer-grid">
          <div>
            <p className="footer-description">
              Db4Cloud Technologies IT Services is the leader in the IT field,
              working on offshore products and outsourcing software development.
            </p>
          </div>

          <div>
            <h4 className="footer-heading">Useful Links</h4>
            <ul className="footer-list">
              <li>
                <Link to="/" className="footer-link">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/what-we-do" className="footer-link">
                  What We Do
                </Link>
              </li>
              <li>
                <Link to="/careers" className="footer-link">
                  Careers
                </Link>
              </li>
              <li>
                <Link to="/contact" className="footer-link">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="footer-heading">Industries</h4>

            <ul className="footer-list">
              <li>
                <Link
                  to="/what-we-do?industry=Education"
                  className="footer-link"
                >
                  Education
                </Link>
              </li>

              <li>
                <Link
                  to="/what-we-do?industry=Finance and Insurance"
                  className="footer-link"
                >
                  Finance
                </Link>
              </li>

              <li>
                <Link
                  to="/what-we-do?industry=Retail and Consumer Goods"
                  className="footer-link"
                >
                  Retail
                </Link>
              </li>

              <li>
                <Link
                  to="/what-we-do?industry=Manufacturing"
                  className="footer-link"
                >
                  Manufacturing
                </Link>
              </li>

              <li>
                <Link
                  to="/what-we-do?industry=Transportation and Logistics"
                  className="footer-link"
                >
                  Automotive
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="footer-heading">Services</h4>
            <ul className="footer-list">
              <li>
                <Link
                  to="/what-we-do?service=Digital+Marketing+Services"
                  className="footer-link"
                >
                  Digital Marketing Services
                </Link>
              </li>
              <li>
                <Link
                  to="/what-we-do?service=Generative+AI+Solutions"
                  className="footer-link"
                >
                  Generative AI Solutions
                </Link>
              </li>
              <li>
                <Link
                  to="/what-we-do?service=DevOps+Solutions"
                  className="footer-link"
                >
                  DevOps Solutions
                </Link>
              </li>
              <li>
                <Link
                  to="/what-we-do?service=Cloud+Computing+Services"
                  className="footer-link"
                >
                  Cloud Compputing Services
                </Link>
              </li>
              <li>
                <Link
                  to="/what-we-do?service=Salesforce+Solutions"
                  className="footer-link"
                >
                  Salesforce Services
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          ©2025 Db4Cloud. All Rights Reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
